/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createPaymentDetails } from "../graphql/mutations";
const client = generateClient();
export default function PaymentDetailsCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    accountName: "",
    IBANNumber: "",
    bankName: "",
    contractValue: "",
    companyName: "",
    swiftCode: "",
    currency: "",
  };
  const [accountName, setAccountName] = React.useState(
    initialValues.accountName
  );
  const [IBANNumber, setIBANNumber] = React.useState(initialValues.IBANNumber);
  const [bankName, setBankName] = React.useState(initialValues.bankName);
  const [contractValue, setContractValue] = React.useState(
    initialValues.contractValue
  );
  const [companyName, setCompanyName] = React.useState(
    initialValues.companyName
  );
  const [swiftCode, setSwiftCode] = React.useState(initialValues.swiftCode);
  const [currency, setCurrency] = React.useState(initialValues.currency);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setAccountName(initialValues.accountName);
    setIBANNumber(initialValues.IBANNumber);
    setBankName(initialValues.bankName);
    setContractValue(initialValues.contractValue);
    setCompanyName(initialValues.companyName);
    setSwiftCode(initialValues.swiftCode);
    setCurrency(initialValues.currency);
    setErrors({});
  };
  const validations = {
    accountName: [],
    IBANNumber: [],
    bankName: [],
    contractValue: [],
    companyName: [],
    swiftCode: [],
    currency: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          accountName,
          IBANNumber,
          bankName,
          contractValue,
          companyName,
          swiftCode,
          currency,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createPaymentDetails.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "PaymentDetailsCreateForm")}
      {...rest}
    >
      <TextField
        label="Account name"
        isRequired={false}
        isReadOnly={false}
        value={accountName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName: value,
              IBANNumber,
              bankName,
              contractValue,
              companyName,
              swiftCode,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.accountName ?? value;
          }
          if (errors.accountName?.hasError) {
            runValidationTasks("accountName", value);
          }
          setAccountName(value);
        }}
        onBlur={() => runValidationTasks("accountName", accountName)}
        errorMessage={errors.accountName?.errorMessage}
        hasError={errors.accountName?.hasError}
        {...getOverrideProps(overrides, "accountName")}
      ></TextField>
      <TextField
        label="Iban number"
        isRequired={false}
        isReadOnly={false}
        value={IBANNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber: value,
              bankName,
              contractValue,
              companyName,
              swiftCode,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.IBANNumber ?? value;
          }
          if (errors.IBANNumber?.hasError) {
            runValidationTasks("IBANNumber", value);
          }
          setIBANNumber(value);
        }}
        onBlur={() => runValidationTasks("IBANNumber", IBANNumber)}
        errorMessage={errors.IBANNumber?.errorMessage}
        hasError={errors.IBANNumber?.hasError}
        {...getOverrideProps(overrides, "IBANNumber")}
      ></TextField>
      <TextField
        label="Bank name"
        isRequired={false}
        isReadOnly={false}
        value={bankName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber,
              bankName: value,
              contractValue,
              companyName,
              swiftCode,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.bankName ?? value;
          }
          if (errors.bankName?.hasError) {
            runValidationTasks("bankName", value);
          }
          setBankName(value);
        }}
        onBlur={() => runValidationTasks("bankName", bankName)}
        errorMessage={errors.bankName?.errorMessage}
        hasError={errors.bankName?.hasError}
        {...getOverrideProps(overrides, "bankName")}
      ></TextField>
      <TextField
        label="Contract value"
        isRequired={false}
        isReadOnly={false}
        value={contractValue}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber,
              bankName,
              contractValue: value,
              companyName,
              swiftCode,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.contractValue ?? value;
          }
          if (errors.contractValue?.hasError) {
            runValidationTasks("contractValue", value);
          }
          setContractValue(value);
        }}
        onBlur={() => runValidationTasks("contractValue", contractValue)}
        errorMessage={errors.contractValue?.errorMessage}
        hasError={errors.contractValue?.hasError}
        {...getOverrideProps(overrides, "contractValue")}
      ></TextField>
      <TextField
        label="Company name"
        isRequired={false}
        isReadOnly={false}
        value={companyName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber,
              bankName,
              contractValue,
              companyName: value,
              swiftCode,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.companyName ?? value;
          }
          if (errors.companyName?.hasError) {
            runValidationTasks("companyName", value);
          }
          setCompanyName(value);
        }}
        onBlur={() => runValidationTasks("companyName", companyName)}
        errorMessage={errors.companyName?.errorMessage}
        hasError={errors.companyName?.hasError}
        {...getOverrideProps(overrides, "companyName")}
      ></TextField>
      <TextField
        label="Swift code"
        isRequired={false}
        isReadOnly={false}
        value={swiftCode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber,
              bankName,
              contractValue,
              companyName,
              swiftCode: value,
              currency,
            };
            const result = onChange(modelFields);
            value = result?.swiftCode ?? value;
          }
          if (errors.swiftCode?.hasError) {
            runValidationTasks("swiftCode", value);
          }
          setSwiftCode(value);
        }}
        onBlur={() => runValidationTasks("swiftCode", swiftCode)}
        errorMessage={errors.swiftCode?.errorMessage}
        hasError={errors.swiftCode?.hasError}
        {...getOverrideProps(overrides, "swiftCode")}
      ></TextField>
      <TextField
        label="Currency"
        isRequired={false}
        isReadOnly={false}
        value={currency}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              accountName,
              IBANNumber,
              bankName,
              contractValue,
              companyName,
              swiftCode,
              currency: value,
            };
            const result = onChange(modelFields);
            value = result?.currency ?? value;
          }
          if (errors.currency?.hasError) {
            runValidationTasks("currency", value);
          }
          setCurrency(value);
        }}
        onBlur={() => runValidationTasks("currency", currency)}
        errorMessage={errors.currency?.errorMessage}
        hasError={errors.currency?.hasError}
        {...getOverrideProps(overrides, "currency")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
